import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class TurnoDBService extends DatabaseService{
    override classname: string = 'TurnoDBService';
    override table = 'turno';

    override indices = [
        {name: "by_id", field: "id", unique: true, multiEntry: false},
        {name: "by_edificacao", field: "edificacao_id", unique: false, multiEntry: false},
        {name: "by_sinc", field: "sinc", unique: false, multiEntry: false}
    ];
}
